module.exports = __webpack_public_path__ + "f3fe14ad49e65c1511d2719a1642aaa2.jpg";